import React from "react";
import { Route, Redirect } from "react-router-dom";
import isLoggedIn from "../utils/isLoggedIn";
import { routes } from "../utils/routesConfig";
import LayoutWrapper from "../Layouts";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn() ? (
          <LayoutWrapper>
            {" "}
            <Component {...props} />
          </LayoutWrapper>
        ) : (
          <Redirect to={routes.HOME} />
        )
      }
    />
  );
};

export default PrivateRoute;
